export default "__VITE_ASSET__2676505e__"